import { Badge, Box, Flex } from '@chakra-ui/react';
import { ApiKeyDto } from '../../../models/api-key/dto/api-key.dto';
import { copy } from '../copy';

type Props = { apiKey: ApiKeyDto };

type Kind = 'active' | 'revoked' | 'expired' | 'stale';

const STALE_DAYS = 90;

function classify(apiKey: ApiKeyDto): Kind {
  if (apiKey.revokedAt) return 'revoked';
  if (apiKey.expiresAt && new Date(apiKey.expiresAt) < new Date())
    return 'expired';
  if (apiKey.lastUsedAt) {
    const ageDays =
      (Date.now() - new Date(apiKey.lastUsedAt).getTime()) / 86_400_000;
    if (ageDays > STALE_DAYS) return 'stale';
  }
  return 'active';
}

const colorScheme: Record<Kind, string> = {
  active: 'green',
  stale: 'orange',
  expired: 'orange',
  revoked: 'gray',
};

export function StatusPill({ apiKey }: Props) {
  const kind = classify(apiKey);
  return (
    <Flex align="center" gap={2}>
      <Box
        w="8px"
        h="8px"
        borderRadius="full"
        bg={`${colorScheme[kind]}.500`}
      />
      <Badge
        colorScheme={colorScheme[kind]}
        variant="subtle"
        fontSize="11px"
        textTransform="none"
      >
        {copy.status[kind]}
      </Badge>
    </Flex>
  );
}
